var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCctv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 88,
    viewBox: "0 0 72 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.95 36.1026C71.95 51.6467 62.73 60.9431 53.1 70.6307C47.28 76.2867 41.67 82.1434 36.05 88C30.44 82.1434 24.82 76.2867 19 70.6307C9.38 60.9431 0 51.6467 0 36.1026C-1.99253e-07 31.3615 0.931187 26.6669 2.74036 22.2867C4.54953 17.9066 7.20125 13.9266 10.5442 10.5742C13.8871 7.22177 17.8557 4.56247 22.2234 2.74815C26.5911 0.933825 31.2724 0 36 0C40.7276 0 45.4089 0.933825 49.7766 2.74815C54.1443 4.56247 58.113 7.22177 61.4559 10.5742C64.7988 13.9266 67.4505 17.9066 69.2597 22.2867C71.0688 26.6669 72 31.3615 72 36.1026H71.95Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 34,
    fill: "#0C3A7E",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6171 38.2199L42.6533 41.3255V47.5366C42.6533 48.069 42.2938 47.9803 41.6647 47.9803H39.8674C39.2383 47.9803 38.8788 48.1577 38.8788 47.4479V42.3015L30.5211 44.6973C30.2515 44.786 29.9819 44.6085 29.8921 44.3423L26.0277 31.299C25.9379 31.0328 26.1176 30.6779 26.4771 30.5891L49.5731 24.0231C49.8427 23.9344 50.2022 24.1118 50.292 24.378L53.9766 37.5101C54.0665 37.7763 53.8868 38.1312 53.6171 38.2199ZM25.9379 36.8003C25.848 36.5341 25.6683 36.3566 25.3987 36.3566L18.6586 35.0256C18.0295 34.8482 17.9396 35.2031 18.0295 35.4693L20.7255 45.0522C20.8154 45.3184 20.9952 45.4958 21.3546 45.3184L26.567 40.4382C26.7467 40.2607 26.9264 40.0833 26.8366 39.8171L25.9379 36.8003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCctv);
export default __webpack_public_path__ + "static/media/cctv.bfc947cdce72293e309973cf744195e1.svg";
export { ForwardRef as ReactComponent };